import React, { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAbility } from '@casl/react';
import { Button, Col, Row } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';
import { debounceLegalreportWorkdayReport } from '../../requests/legalreports';
import { DataTableDT, DefaultModal, Icon, SimpleCenteredModal } from '../../components';
import { AbilityContext } from '../../config/abilityContext';
import { WorkdaysFilterDataTable } from '../../components/LegalReport';
import { downloadFile } from '../../services/utils';
import WorkDayReportFilters from './Filters/NewLegalReportFiltersDt';
import DtLegalReportFilters from './Filters/DtLegalReportFilters';
import WorkdayReportToPrint from './PrintComponent/WorkdayReportToPrint';
import { sendAlert } from '../../actions/utils';
import ReportActions from './ReportActions';
import './Style.scss';
import LegalReportsColumns from './LegalReportsColumns';
import AbbreviationsGlossary from './AbbreviationsGlossary';

export const WorkdayExpander = props => {
  const { data, setDocumentModalBody, setDocumentModalShow } = props;
  const { attendances, is_article_22: isArticle22, employee_id: employeeId } = data;

  return (
    <WorkdaysFilterDataTable
      attendances={attendances}
      isArticle22={isArticle22}
      employeeId={employeeId}
      setDocumentModalBody={setDocumentModalBody}
      setDocumentModalShow={setDocumentModalShow}
    />
  );
};

const WorkdayReportDataTable = ({
  rrhh,
  filters: propFilters,
  bossFilters,
  moreData: propMoreData,
  setMoreData: propSetMoreData,
  isBoss
}) => {
  const [amount, setAmount] = useState(0);
  const [employees, setEmployees] = useState([]);
  const [dataPrint, setDataPrint] = useState([]);
  const [isSubmitting, setSubmitting] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [localMoreData, setLocalMoreData] = useState(false);
  const [onRequest, setOnRequest] = useState(false);
  const [searchFirstStart, setSearchFirstStart] = useState(false);
  const [showFilter, setShowFilter] = useState(true);
  const [tile, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [parameters, setParameters] = useState([]);
  const [filters, setFilters] = useState();
  const [documentModalShow, setDocumentModalShow] = useState(false);
  const [documentModalBody, setDocumentModalBody] = useState('');
  const [dateRange, setDateRange] = useState([]);

  const dispatch = useDispatch();
  const ability = useAbility(AbilityContext);
  const componentRef = useRef();
  const { currentEmployee, user } = useSelector(state => state.auth);

  const printInfo = useReactToPrint({
    content: () => componentRef.current
  });

  const handleFailureRequest = error => {
    const message = error?.response?.data?.message || 'TRABAJADOR NO ENCONTRADO';
    dispatch(sendAlert({ kind: 'error', message }));
  };

  const handleRequest = (params, format = null, type = 'json') => {
    const responseType = params.type === '.docx' ? 'blob' : type;
    const responseFormat = format === '.print' ? '.json' : format;
    const customParams = {
      ...params,
      filter_employee_id: rrhh ? params.filter_employee_id : currentEmployee
    };
    setOnRequest(true);
    setSubmitting(true);
    debounceLegalreportWorkdayReport({
      dispatch,
      params: {
        display_start: 0,
        display_length: 15,
        ...customParams,
        sort_direction: 'asc',
        sort_column: 'name',
        is_dt: false,
        paginate: format === null
      },
      format: responseFormat,
      responseType,
      successCallback: response => {
        const { data } = response;
        if (format === '.xlsx' || format === '.docx' || format === '.pdf') {
          downloadFile(response);
        } else if (format === '.print') {
          setSubmitting(false);
          setDataPrint(data.data.length > 0 ? data.data : [data]);
          printInfo();
        } else {
          setAmount(data.metadata.amount);
          setEmployees(data.data);
        }
      },
      failureCallback: handleFailureRequest,
      callback: () => {
        setOnRequest(false);
        setSubmitting(false);
      }
    });
  };

  const handleMassAction = action => {
    switch (action) {
      case 'download_excel':
        setTitle('Exportar Reporte de Jornada Diaria');
        setBody('¿Estás seguro que quieres exportar el reporte de jornada diaria en formato Excel?');
        setParameters([{ ...filters, type: '.xlsx' }, '.xlsx', 'text']);
        setModalShow(true);
        break;
      case 'download_docx':
        setTitle('Exportar Reporte de Jornada Diaria');
        setBody('¿Estás seguro que quieres exportar el reporte de jornada diaria en formato Word?');
        setParameters([{ ...filters, type: '.docx' }, '.docx', 'text']);

        setModalShow(true);
        break;
      case 'download_pdf':
        setTitle('Exportar Reporte de Jornada Diaria');
        setBody('¿Estás seguro que quieres exportar el reporte de jornada diaria en formato PDF?');
        setParameters([{ ...filters, type: '.pdf' }, '.pdf', 'text']);
        setModalShow(true);
        break;
      case 'print':
        setTitle('Imprimir Reporte de Jornada Diaria');
        setBody('¿Estás seguro que quieres imprimir el reporte de jornada diaria?');
        setParameters([{ ...filters, type: '.print' }, '.print', 'text']);
        setModalShow(true);
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
    }
  };
  const handleFilterAdvance = async params => {
    setFilters(params);
    setDateRange(params.range_date_workday);
    switch (params.type) {
      case null:
        setSearchFirstStart(true);
        if (typeof propSetMoreData === 'function') propSetMoreData(!propMoreData);
        else setLocalMoreData(prev => !prev);
        setShowFilter(false);
        break;
      case '.docx':
        setTitle('Exportar Reporte de Jornada Diaria');
        setBody('¿Estás seguro que quieres exportar el reporte de jornada diaria en formato Word?');
        setParameters([params, '.docx', 'text']);
        setModalShow(true);
        break;
      case '.xlsx':
        setTitle('Exportar Reporte de Jornada Diaria');
        setBody('¿Estás seguro que quieres exportar el reporte de jornada diaria en formato Excel?');
        setParameters([params, '.xlsx', 'text']);
        setModalShow(true);
        break;
      case '.pdf':
        setTitle('Exportar Reporte de Jornada Diaria');
        setBody('¿Estás seguro que quieres exportar el reporte de jornada diaria en formato PDF?');
        setParameters([params, '.pdf', 'text']);
        setModalShow(true);
        break;
      case '.print':
        setTitle('Imprimir Reporte de Jornada Diaria');
        setBody('¿Estás seguro que quieres imprimir el reporte de jornada diaria?');
        setParameters([params, '.print', 'text']);
        setModalShow(true);
        break;
      default:
        break;
    }
  };

  // If this component receives `filters` from parent (e.g., ShowReports), apply them automatically
  const handleRawFilters = () => {
    const rawFilters = propFilters || bossFilters;
    if (!rawFilters || Object.keys(rawFilters).length === 0) return;

    // map incoming `employee_ids` -> `filter_employee_ids` for compatibility
    const effectiveFilters = { ...rawFilters };
    if (Array.isArray(rawFilters.employee_ids) && rawFilters.employee_ids.length > 0) {
      effectiveFilters.filter_employee_ids = rawFilters.employee_ids;
      effectiveFilters.filter_employee_id = '';
      delete effectiveFilters.employee_ids;
    }

    // Reuse existing handler to apply same behavior
    handleFilterAdvance(effectiveFilters);
  };

  const sortColumnCase = name => {
    switch (name) {
      case 'branch_office_address':
        return { sort_branch_offices: name };
      default:
        return { sort_column: name };
    }
  };

  useEffect(handleRawFilters, [propFilters, bossFilters]);

  return (
    <>
      <div className={showFilter ? '' : 'd-none'}>
        {user.role === 'dt' ? (
          <DtLegalReportFilters
            isArial
            filterRRHH={rrhh}
            formRequest={handleFilterAdvance}
            isSubmit={isSubmitting}
            onRequest={onRequest}
          />
        ) : (
          <WorkDayReportFilters
            isArial
            filterRRHH={rrhh}
            formRequest={handleFilterAdvance}
            isSubmit={isSubmitting}
            onRequest={onRequest}
          />
        )}
      </div>
      <div className={showFilter ? 'd-none' : ''}>
        {!isBoss && (
          <Row>
            <Col md={6} className="mt-3">
              <Button variant="primary" onClick={() => setShowFilter(true)}>
                <Icon icon="chevron-back" width={15} />
                <span className="arial-dt">Volver al filtro</span>
              </Button>
            </Col>
          </Row>
        )}

        {!showFilter && <AbbreviationsGlossary />}
        <DataTableDT
          onRequest={onRequest}
          columns={LegalReportsColumns(user.role === 'dt')}
          moreData={typeof propMoreData !== 'undefined' ? propMoreData : localMoreData}
          data={employees}
          responsive
          totalRows={amount}
          handleSortCase={sortColumnCase}
          withMassActions={ability.can('index', 'WorkdayReport')}
          massActions={<ReportActions disabled={onRequest} handleClick={handleMassAction} dates={dateRange} isArial />}
          resourceRequest={params => {
            handleRequest({ ...params, ...filters });
          }}
          expandableRows
          expandableRowExpanded={() => true}
          expandableRowsComponent={
            <WorkdayExpander setDocumentModalBody={setDocumentModalBody} setDocumentModalShow={setDocumentModalShow} />
          }
          searchFirstStart={searchFirstStart}
          noDataComponentText="NO HAY TRABAJADORES QUE COINCIDAN CON LA SELECCIÓN"
        />
      </div>
      <div style={{ display: 'none' }}>
        <WorkdayReportToPrint data={dataPrint} ref={componentRef} />
      </div>
      <DefaultModal
        title={tile}
        body={body}
        show={modalShow}
        handleClose={() => {
          setModalShow(false);
          setSubmitting(false);
        }}
        handleConfirm={() => {
          handleRequest(...parameters);
          setModalShow(false);
        }}
        titleBtnClose="Cancelar"
        titleBtnSave="Confirmar"
      />
      <SimpleCenteredModal
        body={documentModalBody}
        onHide={() => setDocumentModalShow(false)}
        show={documentModalShow}
        size="xl"
      />
    </>
  );
};

export default WorkdayReportDataTable;
